import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, effect, input} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {DateRange} from '@angular/material/datepicker';
import {PageEvent} from '@angular/material/paginator';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {BehaviorSubject, Observable, debounceTime, tap} from 'rxjs';
import {TransactionNotesService} from 'src/app/services/transaction-notes.service';
import {TerraUtils} from 'src/app/shared/TerraUtils';
import {UnitTransactionsDirection} from '../../unit/unit-transactions-list/UnitTransactionDirection';
import TransactionStatus from 'src/app/dashboard/bankAccounts/enums/transactionStatus.enum';
import TransactionType from 'src/app/dashboard/bankAccounts/enums/transactionType.enum';
import {TransactionsDto} from 'src/app/dashboard/bankAccounts/models/transactionsDto.model';
import {ExportTransactionsParameters} from '../../export-transactions-menu/export-transactions-parameters.model';
import {UnitBankAccountService} from '../../unit/unit-bank-account/unit-bank-account.service';

@Component({
  selector: 'terra-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionsListComponent extends OnDestroyMixin implements OnInit {
  @Input("transactions") transactions: TransactionsDto[];
  @Input("exportTransactionsParameters") exportTransactionsParameters: ExportTransactionsParameters;
  @Input("loading") isLoading$: Observable<boolean>;
  @Input("isLp") isLp: boolean;
  filter = input<string>();
  @Input() totalTransactionsNumber: number;
  @Input() pageSize: number;
  @Input() pageNumber: number;
  @Output() onFilterChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() onDirectionChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() onDateRangeChanged: EventEmitter<DateRange<Date>> = new EventEmitter<DateRange<Date>>();
  @Output() onPageSizeChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() onPageNumberChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() onExportSelected: EventEmitter<string> = new EventEmitter<string>();

  pageForm: UntypedFormGroup;
  dateFormat = TerraUtils.consts.DATE_ONLY;
  transactionDirection = UnitTransactionsDirection;
  TransactionType = TransactionType;
  TransactionStatus = TransactionStatus;
  showClearFilter$ = new BehaviorSubject<boolean>(false);
  showClearDirection$ = new BehaviorSubject<boolean>(false);

  constructor(public transactionNotesService: TransactionNotesService,
    private fb: UntypedFormBuilder,
  ) {
    super();
    effect(() => {
      const filterVal = this.filter();
      if (filterVal) {
        this.pageForm.controls.filter.setValue(filterVal);
      }
    });
  }

  ngOnInit(): void {
    this.generateForm();
  }

  clear(fieldName: string) {
    this.pageForm.get(fieldName).setValue(null);
  }

  private generateForm() {
    this.pageForm = this.fb.group({
      filter: null,
      direction: null
    });

    this.pageForm.controls.filter.valueChanges
      .pipe(untilComponentDestroyed(this), debounceTime(300), tap(term => {
        console.log('filter changed!')
        this.showClearFilter$.next(!!term);
        this.onFilterChanged.emit(term || '');
      }))
      .subscribe();

    this.pageForm.controls.direction.valueChanges
      .pipe(
        untilComponentDestroyed(this),
        tap(val => {
          console.log('direction changed!')
          this.showClearDirection$.next(!!val);
          this.onDirectionChanged.emit(val || '');
        })
      ).subscribe();
  }

  pageChange(event: PageEvent) {
    console.log('pageChange called', event)
    this.onPageNumberChanged.emit(event.pageIndex);
  }

  dateRangeChanged(dateRange: DateRange<Date>) {
    this.onDateRangeChanged.emit(dateRange);
  }
  onExportFormatChanged(format: string) {
    this.onExportSelected.emit(format);
  }
}
